import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-0 overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        {/* Left - Image with overlay */}
        <div className="relative flex-1 min-h-[300px] lg:min-h-0">
          <img
            src="https://public.readdy.ai/ai/img_res/3831b73e92f94eb456d83ed85ed034f0.jpg"
            alt="Reader Brothers Workshop"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent flex flex-col justify-end p-10 md:p-16">
            <span className="text-xs uppercase tracking-[3px] text-fuchsia-300 font-bold mb-3">Ready to Start?</span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              LET&apos;S BUILD<br />YOUR VISION
            </h2>
          </div>
        </div>

        {/* Right - CTA Content */}
        <div className="flex-1 bg-white flex flex-col justify-center px-10 md:px-16 py-16">
          <h3 className="text-3xl md:text-4xl font-black text-gray-900 leading-tight mb-6">
            Start Your Project<br />Today
          </h3>
          <p className="text-gray-500 text-base leading-relaxed mb-8 max-w-md">
            Whether you have a fully designed file or just a rough idea scribbled on a napkin — we&apos;re here to make it real. Reach out and let&apos;s talk about your project. No idea is too wild.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-white text-base bg-gradient-to-r from-fuchsia-500 via-orange-400 to-cyan-400 hover:opacity-90 transition-all duration-200 hover:scale-105"
            >
              Get Free Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-gray-700 text-base border-2 border-gray-200 hover:border-fuchsia-400 transition-colors duration-200"
            >
              Learn About Us
            </Link>
          </div>

          {/* Stats */}
          <div className="flex gap-10 mt-12 pt-10 border-t border-gray-100">
            <div>
              <p className="text-3xl font-black bg-gradient-to-r from-fuchsia-500 to-orange-400 bg-clip-text text-transparent">200+</p>
              <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider">Projects Completed</p>
            </div>
            <div>
              <p className="text-3xl font-black bg-gradient-to-r from-orange-400 to-cyan-500 bg-clip-text text-transparent">48hr</p>
              <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider">Avg. Turnaround</p>
            </div>
            <div>
              <p className="text-3xl font-black bg-gradient-to-r from-cyan-500 to-fuchsia-500 bg-clip-text text-transparent">100%</p>
              <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider">Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
